import { render } from "./ResetPasswordTokenView.vue?vue&type=template&id=3a1c72e7"
import script from "./ResetPasswordTokenView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordTokenView.vue?vue&type=script&lang=js"

import exportComponent from "/home/websites/repositories/macgear-scanner/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__